import React from 'react';

import { useFormikContext } from 'formik';

import API from 'utils/api';

import LicenceCoverageNotice, {
  LicenceNoticeSurface,
} from 'components/SharedFormComponents/UserAndGroupPicker/LicenceCoverageNotice';
import useGroupLicencePreview from 'components/SharedFormComponents/UserAndGroupPicker/useGroupLicencePreview';

import { SkippedReason } from 'utils/api/modules/entities/entities.types';

import { AcknowledgementRequestFormValues } from '../schema';

import { buildPreviewBody, groupsIn } from '../utils';

// Built from the groups alone: individually-added recipients are already licence-filtered by the
// picker, so only groups can contribute a shortfall, and the server resolves the deduped counts.
const GroupLicenceNotice: React.FunctionComponent = () => {
  const { values } = useFormikContext<AcknowledgementRequestFormValues>();
  const groups = groupsIn(values.recipients);

  const preview = useGroupLicencePreview(
    groups.map((group) => group.uuid),
    async () => (await API.entities.previewAcknowledgementRecipients(buildPreviewBody(groups))()).data
  );

  if (!preview) return null;

  const licensed = preview.total;
  const missing = preview.skipped.filter((recipient) => recipient.reason === SkippedReason.NoDocumentsLicence).length;

  return (
    <LicenceCoverageNotice
      surface={LicenceNoticeSurface.AcknowledgementRequest}
      total={licensed + missing}
      licensed={licensed}
      groupNames={groups.map((group) => group.name)}
    />
  );
};

export default GroupLicenceNotice;
